import { createAction, props } from "@ngrx/store";
import {
    ConfirmSignUpInput,
    ResetPasswordInput,
    SignInInput,
    SignUpInput,
  } from "@aws-amplify/auth";
import { IAuthState } from "../../interfaces/auth/IAuthState";
import { IAuthServiceGetKeysResponse } from "../../interfaces/authService/IAuthServiceGetKeysResponse";
import { IAuthServiceCreateKeyResponse } from "../../interfaces/authService/IAuthServiceCreateKeyResponse";

export const login = createAction(
    '[Auth] Login',
    props<{ credentials: SignInInput }>()
  );
  
  export const loginSuccess = createAction(
    '[Auth] Login success',
    props<{ authState: IAuthState }>()
  );
  
  export const loginFailure = createAction(
    '[Auth] Login error',
    props<{ error: any }>()
  );
  export const register = createAction(
    "[Auth] Register",
    props<SignUpInput>()
  );
  
  export const registerSuccess = createAction(
    "[Auth] Register Success",
    props<{ aws_id: string; email: string; full_name: string }>()
  );
  
  export const registerFailure = createAction(
    "[Auth] Register Failure",
    props<{ error: string }>()
  );
  export const verifyCode = createAction(
    "[Auth] Verify code",
    props<ConfirmSignUpInput>()
  );
  
  export const verifyCodeSuccess = createAction(
    "[Auth] Verify code Success",
    props<{ user: any | undefined }>()
  );
  
  export const verifyCodeFailure = createAction(
    "[Auth] Verify code Failure",
    props<{ error: string }>()
  );
  export const resetPassword = createAction(
    "[Auth] Reset Password",
    props<ResetPasswordInput>()
  );
  export const resetPasswordSuccess = createAction(
    "[Auth] Reset Password Success",
    props<{ username: string }>()
  );
  export const resetPasswordFailure = createAction(
    "[Auth] Reset Password Failure",
    props<{ error: string }>()
  );
  
  export const changePassword = createAction(
    "[Auth] Change Password",
    props<{ username: string; confirmationCode: string; newPassword: string }>()
  );
  export const changePasswordSuccess = createAction(
    "[Auth] Change Password Success"
  );
  export const changePasswordFailure = createAction(
    "[Auth] Change Password Failure",
    props<{ error: string }>()
  );
  
  export const logout = createAction('[Auth] Logout');

  export const logoutSuccess = createAction('[Auth] Logout Success');
  
  export const logoutFailure = createAction(
    '[Auth] Logout Failure',
    props<{ error: any }>()
  );
  

// auth microservice actions

export const getRefreshKeys = createAction(
  '[Auth] Get Refresh Keys'
)

export const getRefreshKeysFailure = createAction(
  '[Auth] Get Refresh Keys Failure',
  props<{ error: any }>()
)

export const getRefreshKeysSuccess = createAction(
  '[Auth] Get Refresh Keys Success',
  props<{ keys: Array<IAuthServiceGetKeysResponse> }>()
)

export const createRefreshKey = createAction(
  '[Auth] Create Refresh Key'
)

export const createRefreshKeySuccess = createAction(
  '[Auth] Create Refresh Key Success',
  props<{ result: IAuthServiceCreateKeyResponse }>()
)

export const createRefreshKeyFailure = createAction(
  '[Auth] Create Refresh Key Failure',
  props<{ error: any }>()
)

export const clearCreatedRefreshKey = createAction(
  '[Auth] Clear Created Refresh Key'
)

export const revokeRefreshKey = createAction(
  '[Auth] Revoke Refresh Key',
  props<{ uuid: string }>()
)

export const revokeRefreshKeySuccess = createAction(
  '[Auth] Revoke Refresh Key Success',
  props<{ uuid: string }>()
)

export const revokeRefreshKeyFailure = createAction(
  '[Auth] Revoke Refresh Key Failure',
  props<{ error: any }>()
)